const setOccupation = (id = null, val = null) => {
  return {
    type: 'SET_OCCUPATION',
    id,
    data: val,
  }
}

export default {
  setOccupation,
}
